var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpowerOfficeAgent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 511.999 511.999",
    height: 512,
    viewBox: "0 0 511.999 511.999",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m376.001 151h-63.501l76.362-128.28c2.783-4.644 2.856-10.415.19-15.117s-7.646-7.603-13.051-7.603h-120-60c-6.885 0-12.876 4.688-14.546 11.367l-60 241c-1.128 4.482-.117 9.229 2.725 12.861 2.842 3.647 7.207 5.771 11.821 5.771h68.35l-82.397 220.727c-2.637 7.031.337 14.927 6.943 18.486 6.636 3.556 14.846 1.653 19.233-4.395l107.871-149.323 132.129-181.676c3.325-4.556 3.794-10.591 1.245-15.63-2.563-5.024-7.734-8.188-13.374-8.188z",
    fill: "#fed843"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m389.375 159.188c-2.563-5.024-7.734-8.188-13.374-8.188h-63.501l76.362-128.28c2.783-4.644 2.856-10.415.19-15.117s-7.646-7.603-13.051-7.603h-120v356.496l132.129-181.678c3.325-4.555 3.794-10.59 1.245-15.63z",
    fill: "#fabe2c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpowerOfficeAgent);
export default __webpack_public_path__ + "static/media/empower-office-agent.355d48f2761cc587609092fd65a8018c.svg";
export { ForwardRef as ReactComponent };